<template>
  <div>
    <button
      type="button"
      class="btn btn-success btn-labeled btn-labeled-left btn-lg"
      :disabled="submit"
      @click="onMeAssign"
    >
      <b><i class="ri-message-3-line" /></b>
      {{ $t(`${tt}.start_chatting`) }}
    </button>

    <button
      type="button"
      class="btn btn-primary btn-labeled btn-labeled-left btn-lg ml-5"
      :disabled="submit"
      @click="onUserAssign"
    >
      <b><i class="ri-user-line" /></b>
      {{ $t(`${tt}.assign_to_user`) }}
    </button>
    <modal-reassign
      :show.sync="show"
      :disabled="submit"
      :phone-numbers="[room.phone_number]"
      @select="select"
    />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import catchDispatch from '../../../utils/catchDispatch';
import ModalReassign from '../Header/Reassign/ModalReassignHeaderRoomComponents';

export default {
  name: 'ReassignBox',
  components: {
    ModalReassign,
  },
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    tt: 'room.footer.reassign',
    tForm: 'room.header.reassign',
    show: false,
    submit: false,
  }),
  computed: {
    ...mapGetters('auth', ['user']),
  },
  methods: {
    onMeAssign() {
      this.select(this.user?.id);
    },
    onUserAssign() {
      this.show = true
    },
    select(user_id) {
      const chat_id = this.room.id;

      this.submit = true;
      this.$store
        .dispatch('rooms/assign', {chat_id, user_id})
        .then(() => this.show = false)
        .catch(e => catchDispatch.call(this, e))
        .finally(() => this.submit = false);
    },
  },
}
</script>

<style scoped>

</style>
